import { api } from "../App";
import { GET_CULTURE, GET_CULTURE_LOADING } from "./types";
import { createNotification } from "../components/Notifications/Notifications";

export const getCulture = () => async (dispatch) => {
  dispatch({ type: GET_CULTURE_LOADING, payload: true });
  try {
    const { data } = await api.get(`/culture`);
    dispatch({ type: GET_CULTURE, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: GET_CULTURE_LOADING, payload: false });
  }
};

export const createCulture = (data, closeModal) => async (dispatch) => {
  try {
    await api.post(`/culture`, data);
    createNotification('success', 'Успешно');
    await dispatch(getCulture());
    closeModal();
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Не удалось создать запись';
    createNotification('error', errorMessage);
  }
};

export const updateCulture = (data, closeModal) => async (dispatch) => {
  try {
    await api.put(`/culture/${data.id}`, data);
    createNotification('success', 'Успешно');
    await dispatch(getCulture());
    closeModal();
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Не удалось изменить запись';
    createNotification('error', errorMessage);
  }
};

export const deleteCulture = (competenceId) => async (dispatch) => {
  try {
    await api.delete(`/culture/${competenceId}`);
    createNotification('success', 'Успешно');
    await dispatch(getCulture());
  } catch (ERR) {
  }
};
